//import React from 'react';
import ReactDOM from "react-dom/client";

import App from "./App.jsx";
import "./index.css";

const entryPoint = document.getElementById("root");
ReactDOM.createRoot(entryPoint).render(<App />);
//ReactDOM.createRoot(entryPoint).render(React.createElement(App)); //This works as well - you are using react without having to go through the build process
